import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `LineaGenetica/generarExcel`, method: 'POST', body: list, token: token})
}
